import { useLang } from "../../context/LangContext";
import { useStore } from "../../context/StoreContext";

export const AnnouncementBar = () => {
  const { L } = useLang();
  const { settings } = useStore();
  const items = settings?.announcements || [];
  if (!items.length) return null;
  const row = [...items, ...items, ...items, ...items];
  return (
    <div data-testid="announcement-bar" className="relative overflow-hidden bg-ink text-ivory">
      <div className="marquee-track flex w-max gap-16 whitespace-nowrap py-2.5 text-[12px] tracking-[0.14em]">
        {row.concat(row).map((a, i) => (
          <span key={i} className="flex items-center gap-16">
            {L(a, "text")}
            <span className="h-1 w-1 rotate-45 bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
};
